package com.shadowings.gero.presentation.component

import com.shadowings.gero.presentation.util.DevicePreviews
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.WindowInsetsSides
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.only
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.safeDrawing
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.windowInsetsPadding
import androidx.compose.material3.Surface
import androidx.compose.material3.VerticalDivider
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.semantics.testTag
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.shadowings.gero.presentation.ui.AppTheme
import gero.composeapp.generated.resources.*
import org.jetbrains.compose.resources.stringResource

@Composable
fun RightStatsColumn(
    strikeCount: Int,
    level: Int,
    starCount: Int,
    heartsCount: Int,
    showHearts: Boolean = true,
    hasAvailableStreakRestoration: Boolean = false,
    onStatClick: (StatType) -> Unit = {}
) {
    Row(
        modifier = Modifier.fillMaxHeight(),
        verticalAlignment = Alignment.CenterVertically
    ) {
        VerticalDivider(modifier = Modifier.fillMaxHeight())
        Column(
            modifier = Modifier
                .fillMaxHeight()
                .background(androidx.compose.material3.MaterialTheme.colorScheme.background)
                .windowInsetsPadding(
                    WindowInsets.safeDrawing.only(
                        WindowInsetsSides.Right + WindowInsetsSides.Vertical
                    )
                )
                .width(96.dp)
                .padding(vertical = 16.dp, horizontal = 8.dp)
                .semantics { testTag = "right_stats_column" },
            horizontalAlignment = Alignment.Start,
            verticalArrangement = Arrangement.Center
        ) {
            TopBarTag(
                Modifier.clickable { onStatClick(StatType.LEVEL) }.semantics { testTag = "right_stats_stat_level" },
                image = Res.drawable.Y1,
                description = stringResource(Res.string.top_bar_coin_desc),
                count = level
            )
            TopBarTag(
                Modifier.clickable { onStatClick(StatType.STRIKE) }.semantics { testTag = "right_stats_stat_strike" },
                image = Res.drawable.U28,
                description = stringResource(Res.string.top_bar_fire_desc),
                count = strikeCount,
                showBadge = hasAvailableStreakRestoration
            )
            TopBarTag(
                Modifier.clickable { onStatClick(StatType.STAR) }.semantics { testTag = "right_stats_stat_star" },
                image = Res.drawable.N14,
                description = stringResource(Res.string.top_bar_star_desc),
                count = starCount
            )
            if (showHearts) {
                TopBarTag(
                    Modifier.clickable { onStatClick(StatType.HEART) }.semantics { testTag = "right_stats_stat_heart" },
                    image = Res.drawable.F34,
                    description = stringResource(Res.string.top_bar_heart_desc),
                    count = heartsCount
                )
            }
        }
    }
}

@DevicePreviews
@Preview
@Preview(name = "Dark", uiMode = 0x20, showBackground = true)
@Composable
private fun RightStatsColumnPreview() {
    AppTheme {
        Surface {
            RightStatsColumn(
                strikeCount = 5,
                level = 3,
                starCount = 18,
                heartsCount = 5,
                showHearts = true
            )
        }
    }
}
